module.exports = __webpack_public_path__ + "static/media/me-waffles.0522866f.JPG";